import { Paper, Box, Typography, useTheme, SxProps } from "@mui/material";
import { Link } from "react-router-dom";
import { MemberDataAsMember, MemberStatus, MyMembership } from "../../../clients";

interface MyAccountMembershipGeneralInfoProps {
    sx?: SxProps
    membership: MyMembership | null
    sponsoredByMember: MemberDataAsMember | null
}

export const MyAccountMembershipGeneralInfo = ({ sx, membership, sponsoredByMember }: MyAccountMembershipGeneralInfoProps) => {

    const theme = useTheme()
    const address1 = membership?.streetAddress ? membership.streetAddress.split('\n')[0] : 'No address found'
    const address2 = membership?.streetAddress ? membership.streetAddress.split('\n')[1] : ''

    const getMemberStatusFriendlyName = (status: MemberStatus) => {
        switch (status) {
            case MemberStatus.Regular:
                return 'Regular'
            case MemberStatus.Sponsored:
                return 'Sponsored'
            case MemberStatus.DescendantRegular:
                return 'Descendant Regular'
            default:
                return 'Unknown'
        }
    }

    if (!membership) {
        return null
    }

    return (
        <Paper sx={{ ...sx, border: '1px solid', borderColor: theme.palette.secondary.main, borderRadius: '3px', p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography>General Information</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Box sx={{ flex: '1 1 33%', mt: 2 }}>
                    <Typography variant='caption'>Last Name</Typography>
                    <Typography>{membership.familyName}</Typography>
                </Box>
                <Box sx={{ flex: '1 1 33%', mt: 2 }}>
                    <Typography variant='caption'>First Name</Typography>
                    <Typography>{membership.givenName}</Typography>
                </Box>
                <Box sx={{ flex: '1 1 33%', mt: 2 }}>
                    <Typography variant='caption'>Member Status</Typography>
                    <Typography>{getMemberStatusFriendlyName(membership.status)}</Typography>
                </Box>
                {
                    membership.status === MemberStatus.Sponsored &&
                    <Box sx={{ flex: '1 1 100%', mt: 2 }}>
                        <Typography variant='caption'>Sponsored by</Typography>
                        <Typography>
                            <Link style={{ textDecoration: 'none' }} to={`/members/${sponsoredByMember?.memberId}`}>{sponsoredByMember?.memberFamilyName}, {sponsoredByMember?.memberGivenName}</Link>
                        </Typography>
                    </Box>
                }
                {
                    membership.status === MemberStatus.DescendantRegular &&
                    <Box sx={{ flex: '1 1 100%', mt: 2 }}>
                        <Typography variant='caption'>Descendant of</Typography>
                        <Typography>{membership.descendantOf || 'Unknown'}</Typography>
                    </Box>
                }
                <Box sx={{ flex: '1 1 50%', mt: 2 }}>
                    <Typography variant='caption'>Address</Typography>
                    <Typography>{address1}</Typography>
                    <Typography>{address2}</Typography>
                    <Typography>{membership.city}, IN {membership.zipCode}</Typography>
                </Box>
                <Box sx={{ flex: '1 1 50%', mt: 2 }}>
                    <Typography variant='caption'>Member Since</Typography>
                    <Typography>{membership.dateJoined.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' })}</Typography>
                </Box>
                <Box sx={{ flex: '1 1 33%', mt: 2 }}>
                    <Typography variant='caption'>Active</Typography>
                    <Typography>{membership.isActive ? 'True' : 'False'}</Typography>
                </Box>
            </Box>
        </Paper>
    )
}